import { render } from "./NavbarLayout.vue?vue&type=template&id=dd258db0&scoped=true"
import script from "./NavbarLayout.vue?vue&type=script&lang=js"
export * from "./NavbarLayout.vue?vue&type=script&lang=js"

import "./NavbarLayout.vue?vue&type=style&index=0&id=dd258db0&lang=scss&scoped=true"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd258db0"]])

export default __exports__